import Loading from "../../../components/Loading";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "../../../components/Sidebar";
import { Container } from "@mui/material";
import { Settings as SettingsIcon, SlidersHorizontal, User } from "lucide-react";
import { FadeContainer } from "../../../components/FadeContainer";
import { useUserContext } from "../context";
import { TransitionOverlay } from "../../../components/TransitionOverlay";

export const Settings = () => {
    const { userContext } = useUserContext();

    const sideBarSections = [
        {
            visible: true,
            header: "Settings",
            links: [
                {
                    visible: true,
                    title: "Profile",
                    iconComponent: <User />,
                    to: "/settings/profile",
                    text: "Profile",
                    enabled: true,
                    end: true,
                },
                {
                    visible: true,
                    title: "Preferences",
                    iconComponent: <SlidersHorizontal />,
                    to: "/settings/preferences",
                    text: "Preferences",
                    enabled: userContext.projectMemberships.some((p: any) => p.role === "advisor"),
                }
            ]
        }
    ]

    if (!userContext.fetched || !userContext.dbUser) {
        return <TransitionOverlay open={true} message="Loading..." />;
    }

    return (
        <>
            <aside>
                <Sidebar sections={sideBarSections} />
            </aside>
            <FadeContainer component="main">
                <Outlet context={{ user: userContext.dbUser }} />
            </FadeContainer>
        </>
    );
};
